<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">

                <div class="row">
                    <div class="col-md-12">
                        <div *ngIf="!loading">
                            <app-card-skelton title='Events'></app-card-skelton>
                        </div>

                        <app-events *ngIf="loading" [showheader]=false [data]="productData"></app-events>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div style="float: right;">
                            
                            <button type="button"  class="btn color main-backgroundcolor" (click)="navigate()">Update </button>
                            <button type="button"  class="btn color btn-danger margin-l" (click)="deleteEvent()">Delete </button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>

<router-outlet></router-outlet>